<template>
  <Modal id="materials-delete">
    <div class="materials-delete-title">{{ $t('ModalMaterialsDelete.title') }}</div>
    <div class="materials-delete__content">
      <div class="Material-delete__preview">
        <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5.6 1.5C3.61177 1.5 2 3.11178 2 5.1V12.9C2 14.8882 3.61178 16.5 5.6 16.5H10.8C12.7882 16.5 14.4 14.8882 14.4 12.9V7.73696C14.4 6.78218 14.0207 5.8665 13.3456 5.19137L10.7086 2.55442C10.0335 1.87928 9.11783 1.5 8.16305 1.5H5.6Z" stroke="#CCD7E6" stroke-width="2"/>
          <path d="M9.06689 1.67334L9.06689 6.48667C9.06689 6.96532 9.45491 7.35334 9.93356 7.35334H14.2269" stroke="#CCD7E6" stroke-width="2"/>
        </svg>
      </div>
      <div class="Material-delete__name">
        {{name}}
      </div>
    </div>
    <div class="actions">
      <button class="red border" @click="onRemove">
        {{ $t('delete') }}
      </button>
      <button class="border" @click="closeModal">{{ $t('cancel') }}</button>
    </div>
  </Modal>
</template>

<script>
import Modal from '@/components/modals/Modal'
import InputFile from '@/components/form/InputFile'
import FileList from '@/components/form/FileList'
import { mapActions, mapMutations, mapState } from 'vuex'
import getEvents from '../../mixins/getEvents'
import moment from 'moment'

export default {
  name: 'ModalMaterialsDelete',
  components: { FileList, InputFile, Modal },
  mixins: [getEvents],
  computed: {
    name() {
      return this.modalOptions?.name.replace(/\.(\w*$)/, '')
    },
    ...mapState('events', ['events', 'b2b', 'eventsFiltered', 'actualEvent', 'pending']),
    ...mapState(['modal', 'modalOptions']),
  },
  methods: {
    ...mapMutations(['closeModal']),
    ...mapActions('library', ['removeLibrary']),
    onRemove() {
      this.removeLibrary([this.modalOptions?.id]);
      this.closeModal();
    },
  },
}
</script>

<style lang="scss">
#modal-materials-delete {
  .content {
    width: 355px;
  }
  .materials-delete-title {
    margin-bottom: 20px;

    font-size: 24px;
    font-weight: 700;
    line-height: 27.84px;

    color: #353535;
  }

  input {
    margin-bottom: 7px;
  }

  .materials-delete__content {
    display: flex;
    align-items: center;
  }

  .Material-delete__preview {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    height: 35px;
    width: 35px;
    border-radius: 10px;
    background: #CCD7E64D;
  }

  .Material-delete__name {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-left: 10px;
  }

  textarea {
    -webkit-appearance: none;
    height: auto;
    min-height: 72px;
    resize: none;
    margin-bottom: 20px;
    padding: 9px 14px;

    @include mobile {
      min-height: 114px;
    }
  }

  select {
    height: 40px;
  }

  .actions {
    margin-top: 30px;
  }
}
</style>
